import React, { useEffect } from 'react';
import api from '../api/axios';

function Home() {
  useEffect(() => {
    // Panggil API saat halaman Home dimuat
    api.get('/api/check-midtrans/all')
      .then(response => {
        console.log('Midtrans check success', response.data);
      })
      .catch(error => {
        console.error('Gagal memeriksa Midtrans:', error);
      });
  }, []);

  return (
    <div className="container py-5">
      <div className="mb-5 text-center">
        <h1 className="display-4 fw-bold">
          <span style={{ color: 'black' }}>Conex</span>
          <span style={{ color: '#F68D6E' }}>see</span>
        </h1>
        <p className="fs-5">
          <span style={{ color: 'black' }}>Connect your career, </span>
          <span style={{ color: '#F68D6E' }}>See your future</span>
        </p>
      </div>

      <div className="row g-4">
        <div className="col-md-4">
          <div className="p-4 bg-warning-subtle rounded shadow-sm h-100">
            <h5 className="fw-bold">What’s our value?</h5>
            <p className="mb-0">Our community is built based on a value, <em>“be more connected”</em></p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4 bg-warning-subtle rounded shadow-sm h-100">
            <h5 className="fw-bold">Who are we?</h5>
            <p className="mb-0">A community that helps students to expand their network with other students and experts</p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4 bg-warning-subtle rounded shadow-sm h-100">
            <h5 className="fw-bold">What’s our purpose?</h5>
            <p className="mb-0">To help student achieve their better career preference</p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4 bg-dark text-white rounded shadow-sm h-100">
            <h5 className="fw-bold">Expert Connect</h5>
            <p className="mb-0">We aim to help you to connect with expert personally in meaningful way</p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4 bg-dark text-white rounded shadow-sm h-100">
            <h5 className="fw-bold">Insight Sharing</h5>
            <p className="mb-0">We provide insightful shares to improve your professional capabilities</p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-4 bg-dark text-white rounded shadow-sm h-100">
            <h5 className="fw-bold">Community Forum</h5>
            <p className="mb-0">We enable all members to stay in touch to support each other</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
